// extracted by mini-css-extract-plugin
export default {"tupacGrid":"tm-z","tupacHeader":"um-z","tupacHeader2":"vm-z","tupacMenu":"wm-z","tupacMenu2":"xm-z","tupacMain":"ym-z","tupacMain2":"zm-z"};